export default (language) => {
  return [(language === 'en' ? 'base' : language).replace('-', '_')]
}
